module.exports = __webpack_public_path__ + "static/media/fourth-new.852eb383.webp";